module.exports = __webpack_public_path__ + "static/media/icon-doc.6daa25d5.svg";